import React, { forwardRef, useImperativeHandle, useReducer } from "react";

const DoubleValRenderer = forwardRef((props, ref) => {
    const [, forceUpdate] = useReducer(v => v + 1, 0);

    const getFormattedValue = () => {
        const val = props.getValue();
        if (val == null || val === "") return null;

        const precision = props.colDef.cellRendererParams?.precision ?? 2;
        return val == "-" ? "-" : parseFloat(val.toString().replace(",", ".")).toFixed(precision);
    };

    useImperativeHandle(ref, () => ({
        refresh() {
            forceUpdate();
            return true;
        }
    }));

    const val = getFormattedValue();

    return (
        <span className="editableCell">
            {val !== null ? (
                val
            ) : (
                <div>
                    <span className="addtext"></span>
                    <div className="addtextafter"><i className="fa fa-plus"></i></div>
                </div>
            )}
        </span>
    );
});

export default DoubleValRenderer;
